import { inputValidFloat } from './validator'
// 保留小数-精度
export function Amount(value, fix = 2, int = true) {
    return Number(inputValidFloat(`${value}`, fix, int))
}

// 保留小数-计算
export function AmountDecimal(value, fix = 2) {
    if (!value) {
        return 0
    }
    if (value === '-' || value === '--') {
        return value
    }
    let num = Number(value)
    let roundNum = Math.pow(100, fix / 2)
    num = Math.round(num * roundNum)
    // num = parseFloat(num / roundNum).toFixed(fix)
    num = String(num / roundNum).replace(/(\.\d{fix})\d+$/, '$1')
    return Number(num)
}


// WEBPACK FOOTER //
// ./src/utils/price.js